import { render, staticRenderFns } from "./trifle-change.vue?vue&type=template&id=4f8aa362&scoped=true&"
import script from "./trifle-change.vue?vue&type=script&lang=js&"
export * from "./trifle-change.vue?vue&type=script&lang=js&"
import style0 from "./trifle-change.vue?vue&type=style&index=0&lang=css&"
import style1 from "./trifle-change.vue?vue&type=style&index=1&id=4f8aa362&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8aa362",
  null
  
)

export default component.exports